export enum StepsEnum {
  UPLOAD = 0,
  PROJECT_AND_DETAILS = 1,
  SUMMARY = 2,
}
